<template>
    <div class="equipeItem">
    <s-button :label="(index+1)" icon="" theme="is-small is-info" @onclick="openEquipe(joueur)"/>
    <a class="nameEquipe" @click="openEquipe(joueur)">{{nameEquipe}}</a>
    <div class="joueurItem" v-if="joueurCompose">
        <div class="subJoueur">
            
            <b>{{joueurCompose.pseudo}}</b>
            <div class="nomprenom">
                 {{joueurCompose.nom}} {{joueurCompose.prenom}} 
            </div>&nbsp;
        </div>
        <div  class="subJoueur"> 
            <span v-if="joueurCompose.coequipier1DATA">{{joueurCompose.coequipier1DATA.pseudo}}</span> 
            <div class="nomprenom" >
                    <span v-if="joueurCompose.coequipier1DATA">
                        {{joueurCompose.coequipier1DATA.nom}} {{joueurCompose.coequipier1DATA.prenom}} 
                </span>
                
            </div>
              
        </div>
        <div  class="subJoueur">  
            <span v-if="joueurCompose.coequipier2DATA">{{joueurCompose.coequipier2DATA.pseudo}}</span> 
            <div class="nomprenom" >
                <span v-if="joueurCompose.coequipier2DATA">
                        {{joueurCompose.coequipier2DATA.nom}} {{joueurCompose.coequipier2DATA.prenom}} 
                </span>
            </div>
                
        </div>
    </div>
    </div>
</template>
<style scoped>
    .nameEquipe {
        font-weight: bolder;
        margin-left: 5px;
        text-decoration: underline;
        color: black;
    }
    .nameEquipe:hover {
        cursor: hand;
    }
    .equipeItem {
        display: inline-block;
        width: 165px;
        height: 170px;
        border: thin dashed silver;
        border-radius: 10px;
        margin: 10px;
        padding: 5px;
        
    }
    .joueurItem {
        font-size: 14px;
        
    } 
    .subJoueur {
        height: 40px;
        margin-top: 2px;
    }
    .nomprenom {
        font-style:italic;
        font-size:12px;
    }
</style>
<script>
import tournoi_fct from '@/firebase/tournoi'
export default {
    props: ['club','tournoi', 'role','joueur', 'index'],    
    data() {
        return {
            joueurCompose: null
        }
    },
    watch: {
        joueur() {
            this.init();
        }
    },
    computed: {
        nameEquipe: {
            get() {
                var nameEquipe = this.joueur.pseudo
                if (typeof(this.joueur.nameEquipe)!="undefined")
                    if (this.joueur.nameEquipe!="")
                        nameEquipe = this.joueur.nameEquipe;
                return nameEquipe;
            }
        }
    },
    methods: {
       
        desinscrire() {
           this.$emit("deleteEquipe", this.joueur)
        },
        openEquipe() {
            this.$emit("openEquipe",this.joueur)
        },
        init() {
            this.joueurCompose = JSON.parse(JSON.stringify(this.joueur));
            if (this.joueurCompose.pseudo=="")
                this.joueurCompose.pseudo = "invite";
            this.joueurCompose.coequipier1DATA = null;
            if (this.joueurCompose.coequipier1!=null) {
                var indexJoueur = this.tournoi.joueurs.findIndex(joueur=>joueur.id===this.joueurCompose.coequipier1);
                if (indexJoueur!=-1) {
                    this.joueurCompose.coequipier1DATA = JSON.parse(JSON.stringify(this.tournoi.joueurs[indexJoueur]));
                    if (this.joueurCompose.coequipier1DATA.pseudo=="")
                        this.joueurCompose.coequipier1DATA.pseudo = "invite";
                }
            }
            this.joueurCompose.coequipier2DATA = null;
            if (this.joueurCompose.coequipier2!=null) {
                var indexJoueur = this.tournoi.joueurs.findIndex(joueur=>joueur.id===this.joueurCompose.coequipier2);
                if (indexJoueur!=-1) {
                    this.joueurCompose.coequipier2DATA = JSON.parse(JSON.stringify(this.tournoi.joueurs[indexJoueur]));
                     if (this.joueurCompose.coequipier2DATA.pseudo=="")
                        this.joueurCompose.coequipier2DATA.pseudo = "invite";
                }
            }
        }
    },
    mounted() {
        this.init();
    }

}
</script>
